import { render, staticRenderFns } from "./BarChartContractual.vue?vue&type=template&id=6cbb3604&"
import script from "./BarChartContractual.vue?vue&type=script&lang=js&"
export * from "./BarChartContractual.vue?vue&type=script&lang=js&"
import style0 from "./BarChartContractual.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports